module.exports = __webpack_public_path__ + "media/images/slide-3-16c97e7a72bf2c4511af29b35b5fea45.jpg";